import { invitesService, accountUserService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import {
  SET_INVITES,
  ADD_NEW_INVITE,
  REMOVE_DELETED_INVITES,
  REMOVE_UNLINKED_USER
} from './mutationTypes';

import {
  GET_INVITES,
  DELETE_INVITE,
  DELETE_USER,
  INVITE_USER
} from './actionTypes';

import { SET_ACTION_STATUS_PENDING, SET_ACTION_STATUS_ERROR, SET_ACTION_STATUS_SUCCESS } from '@/store/helpers';

const actions = {
  async [GET_INVITES]({ rootState, commit }, { inviteTargetType, inviteTargetId }) {
    commit(SET_ACTION_STATUS_PENDING, {actionName: GET_INVITES });
    // commit(GET_INVITES, { inviteTargetType, inviteTargetId, invites:[] });
    try {
      const invitations = await invitesService.getInvites(inviteTargetType, {
        accountId: rootState.currentAccountId,
        inviteAccountTypeId: inviteTargetId
      });
      const responseUsers = await invitesService.getSpecificUsers(rootState.currentAccountId, inviteTargetType, inviteTargetId);
      
      const invitesWithUsers = invitations.reduce((invites, invite) => {
        invite.user = responseUsers.data.users.find((user) => user.email.toLowerCase() == invite.email.toLowerCase());
        if (invite.user) {
          invite.user.hasInvite = true;
        } 
        
        if (invite.status !== 'Accepted' || (invite.status === 'Accepted' && invite.user)) {
          invites.push(invite);
        }
        
        return invites;
      }, []);

      responseUsers.data.users.forEach(u => {
        if (!u.hasInvite) {
          // TODO: Move to invite service function
          invitesWithUsers.push({
            acceptanceDate: '2021-03-25T00:00:00.0000000Z',
            associatedRoleIds: [inviteTargetId],
            createdDate: '2021-03-25T00:00:00.0000000Z',
            email: u.email,
            enabled: true,
            expirationDate: '2021-04-24T00:00:00.0000000Z',
            firstName: u.firstName,
            id: 'USER' + u.id,
            isActive: false,
            lastName: u.lastName,
            role: u.accounts.find(a => a.accountId === rootState.currentAccountId)?.roles?.[0],
            url: '',
            user: u,
            name: u.name,
            status: 'Accepted',
            statusClass: 'label-success'
          });
        }
      });
      commit(SET_INVITES, { inviteTargetType, inviteTargetId, invites: invitesWithUsers });
      commit(SET_ACTION_STATUS_SUCCESS, {actionName: GET_INVITES });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, {actionName: GET_INVITES, error: e });
    }
  },
  async [DELETE_INVITE]({ rootState, state, commit }, { inviteTargetType, inviteTargetId, invite }) {
    commit(SET_ACTION_STATUS_PENDING, {actionName: DELETE_INVITE });
    try {
      const invitesWithSameEmail = [
        invite,
        ...(state.invites?.inviteTargetType?.inviteTargetId?.length
          ? state.invites.inviteTargetType.inviteTargetId.filter((i) => i.email === invite.email && i.id !== invite.id)
          : [])
      ];
      const deletePromises = [];
      invitesWithSameEmail.forEach((i) =>
        deletePromises.push(invitesService.deleteInvite(inviteTargetType, {
          inviteAccountTypeId: inviteTargetId,
          accountId: rootState.currentAccountId,
          inviteId: i.id
        }))
      );
      const result = await Promise.allSettled(deletePromises);
      const deletedInviteIds = [];
      let errorDetected = false;
      for (let index = 0; index < result.length; index++) {
        if (result[index]?.value?.status == 200) {
          deletedInviteIds.push(invitesWithSameEmail[index].id);
        } else {
          errorDetected = true;
        }
      }

      if (errorDetected) {
        commit(SET_ACTION_STATUS_ERROR, {actionName: DELETE_INVITE, errorMessage: 'One or more invitation deletes have failed'});  
      } else {
        commit(SET_ACTION_STATUS_SUCCESS, {actionName: DELETE_INVITE });
      }
      commit(REMOVE_DELETED_INVITES, { inviteTargetType, inviteTargetId, deletedInviteIds });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, {actionName: DELETE_INVITE, error: e });
    }
  },
  async [DELETE_USER]({ rootState, commit }, { inviteTargetType, inviteTargetId, invite }) {
    commit(SET_ACTION_STATUS_PENDING, {actionName: DELETE_USER });
    try {
      if (invite?.user?.id) {
        await accountUserService.deleteAccountUser(rootState.currentAccountId, invite.user.id);
        commit(REMOVE_UNLINKED_USER, { inviteTargetType, inviteTargetId, unlinkedUserId: invite.user.id });
      }
      commit(SET_ACTION_STATUS_SUCCESS, {actionName: DELETE_USER });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, {actionName: DELETE_USER, error: e });
    }
  },
  async [INVITE_USER]({ rootState, commit }, { inviteTargetType, inviteTargetId, invite }) {
    commit(SET_ACTION_STATUS_PENDING, {actionName: INVITE_USER });
    try {
      const response = await invitesService.inviteUser(inviteTargetType, {
        inviteAccountTypeId: inviteTargetId,
        accountId: rootState.currentAccountId
      }, invite);
      commit(SET_ACTION_STATUS_SUCCESS, {actionName: INVITE_USER });
      commit(ADD_NEW_INVITE, { inviteTargetType, inviteTargetId, newInvite: response });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, {actionName: INVITE_USER, error: e });
    }
  }
};

export default actions;